export default {
  "authentication": {
    "local": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": 'df178d25-15f3-45db-b736-ab52a27dbac2',
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
    },
    "develop": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": '54662900-cd0c-4f21-96ba-19dc34711801',
      "domain": "https://cbdigitaldev.b2clogin.com/cbdigitaldev.onmicrosoft.com"
    },
    "development": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": '54662900-cd0c-4f21-96ba-19dc34711801',
      "domain": "https://cbdigitaldev.b2clogin.com/cbdigitaldev.onmicrosoft.com"
    },
    "qa": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": 'df178d25-15f3-45db-b736-ab52a27dbac2',
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
    },
    "stage": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": 'df178d25-15f3-45db-b736-ab52a27dbac2',
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
    },
    "production": {
      "policy": "B2C_1A_DigitalStore_signup_signin",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": '40335d1d-0ee8-437c-906a-55e94f2022c6',
      "domain": "https://cbdigitalprd.b2clogin.com/cbdigitalprd.onmicrosoft.com"
    }
  },
  "storeauthentication": {
    "local": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "6eb68e48-7c7d-46ed-8d8d-fba81c6e65b7",
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
      "authority": "https://cbdigitalqa.b2clogin.com/"
    },
    "develop": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "6eb68e48-7c7d-46ed-8d8d-fba81c6e65b7",
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
      "authority": "https://cbdigitalqa.b2clogin.com/"
    },
    "development": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "6eb68e48-7c7d-46ed-8d8d-fba81c6e65b7",
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
      "authority": "https://cbdigitalqa.b2clogin.com/"
    },
    "qa": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "6eb68e48-7c7d-46ed-8d8d-fba81c6e65b7",
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
      "authority": "https://cbdigitalqa.b2clogin.com/"
    },
    "stage": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "6eb68e48-7c7d-46ed-8d8d-fba81c6e65b7",
      "domain": "https://cbdigitalqa.b2clogin.com/cbdigitalqa.onmicrosoft.com",
      "authority": "https://cbdigitalqa.b2clogin.com/"
    },
    "production": {
      "policy": "B2C_1_StoreSignIn",
      "profilePolicy": "B2C_1A_DigitalStore_ProfileEdit",
      "passwordPolicy": "B2C_1A_DigitalStore_PasswordReset",
      "clientId": "fdebde95-1e48-4030-8ef2-c75d3c1373ab",
      "domain": "https://cbdigitalprd.b2clogin.com/cbdigitalprd.onmicrosoft.com",
      "authority": "https://cbdigitalprd.b2clogin.com/"
    },
  },
}
